import React from 'react';
import { enquireScreen } from 'enquire-js';
import Banner3 from '../../compoment/Banner3';//1
import Feature1 from '../../compoment/Feature1';//2
import Content5 from '../../compoment/Content5';//3
import Feature3 from '../../compoment/Feature3';//4
import Feature5 from '../../compoment/Feature5';//5核心价值及技术优势
import Footer1 from '../../compoment/Footer1';//页脚单独引
import {Footer10DataSource} from '../../data/head.source'//页脚单独引
import {
    Banner30DataSource,//1
    Feature10DataSource,//2
    Content50DataSource,//3
    Feature30DataSource,//4
    Feature51DataSource//5核心价值和技术优势 
} from '../../data/dcsyuce.source';
import '../../assets/less/antMotionStyle.less';
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});
const { location = {} } = typeof window !== 'undefined' ? window : {};
export default class dcsyuce extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: !location.port, 
        };
    }
    componentDidMount () {
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });
        if (location.port) {
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
    }
    render () {
        const children = [
            <Banner3
                key="yuceBanner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <Feature1
                id="Feature1_0"
                key="Feature1_0"
                dataSource={Feature10DataSource}
                isMobile={this.state.isMobile}
            />,
             <Feature3
                id="Feature3_0"
                key="Feature3_0"
                dataSource={Feature30DataSource}
                isMobile={this.state.isMobile}
            />,
              <Feature5
            id="Feature5_1"
            key="Feature5_1"
            dataSource={Feature51DataSource}
            isMobile={this.state.isMobile}
        />,
            <Content5
                id="Content5_0"
                key="Content5_0"
                dataSource={Content50DataSource}
                isMobile={this.state.isMobile}
            />,
           
          
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            /> 
        ];
        return (
            <div className="templates-wrapper" ref={(d) => { this.dom = d; }}>
                {this.state.show && children}
            </div>
        );
    }
}
